import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, MaxValidator, ValidatorFn, Validators } from '@angular/forms';
import { SalesService } from '../../sales.service';
import { CommonService } from '../../../../services/common';
import { environment } from '../../../../../environments/environment';
import { IconList } from '../../../../../iconlist';
import { ToasterService } from '../../../../services/common/toaster.service';

export function totalPercentageValidator(): ValidatorFn {
  return (formArray: AbstractControl): { [key: string]: any } | null => {
    if (!(formArray instanceof FormArray)) {
      return null;
    }
    const total = formArray.controls.reduce((sum, control) => {
      const value = control.get('amountPercentage')?.value;
      return sum + (value || 0);
    }, 0);
    return total === 100 ? null : { totalPercentageInvalid: true };
  };
}

@Component({
  selector: 'app-payment-plan-add-update',
  templateUrl: './payment-plan-add-update.component.html',
  styleUrl: './payment-plan-add-update.component.scss'
})
export class PaymentPlanAddUpdateComponent {
  @Input() currentAddUpdatePayment: any;
  @Output() changeModalStatus = new EventEmitter<any>()

  paymentPlanForm!: FormGroup;
  Submitted = false;
  Project: any;
  paymentAddData: any;
  currentPayment: any;
  items: any
  orderValue: any
  addArrayIcon: string = environment.assetsImagePath + IconList.addIconPaymentPlans
  deleteArrayIcon: string = environment.assetsImagePath + IconList.deleteIconPaymentPlans

  constructor(private fb: FormBuilder, private saleService: SalesService, private toasterService: ToasterService) {

  }

  ngOnInit() {
    this.currentPayment = this.currentAddUpdatePayment
    this.initiatePaymentPlanForm()
    this.Project = JSON.parse((localStorage.getItem('selectedProject') as any));
    this.paymentPlanForm.controls['projectName'].setValue(this.Project?.projectName);
    for (let i = 0; i < this.currentPayment?.paymentStages?.length; i++) {
      this.orderValue = this.currentPayment.paymentStages[i];

    }
  }
  get f(): { [ket: string]: AbstractControl } {
    return this.paymentPlanForm.controls;
  }

  /**
 * Payment-Plan Form Controls Key
 */
  initiatePaymentPlanForm() {
    this.paymentPlanForm = this.fb.group({
      paymentStages: this.fb.array([], { validators: totalPercentageValidator() }),
      projectId: this.currentPayment?.projectId,
      projectName: this.Project?.projectName,
      id: this.currentPayment?.id,
      name: [this.currentPayment?.name, [Validators.required]],
    })
    this.addPaymentStages();
  }


  // Populate payment stages from currentPayment
  private addPaymentStages(): void {
    const paymentStagesArray = this.paymentPlanArray;
    if (this.currentPayment?.paymentStages?.length == 0 || this.currentPayment?.paymentStages == undefined) {
      this.addAddressGroup();
    } else {
      this.currentPayment?.paymentStages.forEach((stage: any) => {
        const group = this.fb.group({
          name: [stage.name],
          stageOrder: [Number(this.paymentPlanForm?.value.paymentStages.length) || 0],
          dueInDays: [stage.dueInDays],
          amountPercentage: [stage.amountPercentage],
          isActive: [true],
        });
        paymentStagesArray.push(group);
      });
    }
  }

  //Append Fields Set
  public addAddressGroup(): void {
    const paymentStagesArray = this.paymentPlanArray;

    const group = this.fb.group({
      name: [''],
      stageOrder: Number(this.paymentPlanForm?.value.paymentStages.length) || 0,
      dueInDays: [null],
      amountPercentage: [null],
    });
    paymentStagesArray.push(group);

  }

  onSubmit() {
    this.Submitted = true
    if (this.paymentPlanForm.invalid) {
      return;
    }
    else {
      var data = this.paymentPlanForm?.value;
      if (data?.id > 0) {
        this.saleService.updatePaymentPlanData(data.id, this.paymentPlanForm.value).subscribe((res: any) => {
          this.Submitted = false;
          this.toasterService.showSuccess('Payment Plan succcesfully');
          this.changeModalState(true)
        })
      }
      // Post Payment Plan API
      else {
        this.paymentPlanForm.value.projectId = this.Project?.id,
          this.saleService.postPaymentPlanData(this.paymentPlanForm.value).subscribe((res: any) => {
            this.paymentAddData = res
            this.toasterService.showSuccess('Payment Plan added succcesfully');
            this.Submitted = false;
            this.changeModalState(true)
          })
      }
    }
  }


  //Remove Fields
  removeaddField(index: number): void {
    this.paymentPlanArray.removeAt(index);
  }

  //Fields Array
  get paymentPlanArray(): FormArray {
    return <FormArray>this.paymentPlanForm.get('paymentStages');
  }

  /**
   * Change the Add/Update modal state to display or hide
   * @param isSubmitted defines if current record was submitted to add/update or not. If yes then refresh booking list otherwise not
   */
  changeModalState(isSubmitted: boolean = false) {
    this.changeModalStatus.emit({
      "showaddUpdateModal": false,
      "isSubmitted": isSubmitted
    });
  }
}
